// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"R2-z","displaySixCardTiles":"S2-z"};